module.exports = __webpack_public_path__ + "static/media/mcardle.1cdda272.png";